// @ts-nocheck
// Estudo 2.0 — Cards (texto unificado, Lição, Quiz, Caixa, Líder, Insight). Portado do protótipo Claude Design.
import React, { useState } from 'react';
import {
  IcoFlame, IcoQuestion, IcoInbox, IcoCrown, IcoTrophy,
  IcoBulb, IcoComment, IcoMore, IcoBack, IcoCheck, IcoChevron, IcoLock, IcoPlus, IcoClock, IcoArrowUp, IcoTeach, IcoTheme,
} from './icons2';
import {
  Avatar, BookCover, RichText, inlineRich, REACTIONS, POST_TYPES, TypeBadge, PageChip,
  fmt, stripMd, parseLicao, isLicao, postHeat,
} from './ui2';

export const StudyContext = React.createContext<any>(null);
export const useStudy = () => React.useContext(StudyContext);

/* ---------- Barra de reações ---------- */
export function reactBtn(active: boolean, color: string) {
  return {
    display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 12.5, fontWeight: 600,
    color: active ? color : 'var(--ink-3)', padding: '6px 9px', borderRadius: 10,
    background: active ? 'color-mix(in oklab, ' + color + ' 13%, transparent)' : 'transparent',
    transition: 'background 0.18s, color 0.18s', lineHeight: 1,
  };
}
export function ReactionBar({ post, hideComment, trailing }: any) {
  const { onReact, onOpenComments, canPost } = useStudy();
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 2, marginTop: 4 }}>
      {REACTIONS.map((r: any) => {
        const active = (post.yourReactions || []).includes(r.id);
        const count = post.reactions?.[r.id] || 0;
        const Icon = r.Icon;
        return (
          <button key={r.id} onClick={() => onReact(post.id, r.id)} style={{ ...reactBtn(active, r.accent), opacity: canPost === false ? 0.45 : 1, cursor: canPost === false ? 'not-allowed' : 'pointer' }} aria-label={r.label}>
            <Icon size={16} fill={active ? r.accent : 'none'} />
            {count > 0 && <span>{fmt(count)}</span>}
          </button>);
      })}
      <div style={{ flex: 1 }} />
      {trailing}
      {!hideComment &&
      <button onClick={() => onOpenComments(post)} style={{
        display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 13, fontWeight: 600,
        color: post.comments > 0 ? 'var(--ink-2)' : 'var(--ink-3)', padding: '6px 9px', borderRadius: 10,
      }}>
        <IcoComment size={16} />{post.comments > 0 ? post.comments : 'Discutir'}
      </button>}
    </div>);
}

/* ---------- Linha de autor (com authorBook mini-pill) ---------- */
export function AuthorRow({ post }: any) {
  const { onMenu, onOpenProfile } = useStudy();
  const isAdmin = post.author?.role === 'Admin';
  const goAuthor = (e: any) => { e?.stopPropagation?.(); if (onOpenProfile && post.author?.id) onOpenProfile(post.author.id); };
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <span onClick={goAuthor} style={{ cursor: onOpenProfile ? 'pointer' : 'default', lineHeight: 0, flexShrink: 0 }}><Avatar user={post.author} size={36} ring={isAdmin ? 'var(--ember)' : null} /></span>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span onClick={goAuthor} style={{ fontWeight: 600, fontSize: 14, color: 'var(--ink)', cursor: onOpenProfile ? 'pointer' : 'default' }}>{post.author?.name}</span>
          {isAdmin && <IcoCrown size={13} style={{ color: 'var(--ember)' }} />}
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginTop: 1 }}>
          <span className="mono" style={{ fontSize: 11, color: 'var(--ink-4)' }}>{post.timeAgo}</span>
          {post.authorBook &&
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, minWidth: 0 }}>
              <span style={{ color: 'var(--ink-4)' }}>·</span>
              <BookCover book={post.authorBook} w={13} h={18} />
              <span style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic', fontSize: 12.5, color: 'var(--ink-3)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: 130 }}>{post.authorBook.title}</span>
            </span>}
        </div>
      </div>
      {post.page && <PageChip page={post.page} />}
      <button onClick={() => onMenu(post)} style={{ color: 'var(--ink-4)', padding: 4, marginLeft: 2 }} aria-label="Mais"><IcoMore size={18} /></button>
    </div>);
}

/* ---------- Shell genérico de card ---------- */
export function CardShell({ post, accent, children, onClick, glow }: any) {
  return (
    <article onClick={onClick} style={{
      background: 'var(--paper-2)', borderRadius: 16, border: '1px solid var(--line)',
      padding: '16px 16px 12px', boxShadow: 'var(--shadow-card)', position: 'relative',
      borderLeft: accent ? `2.5px solid ${accent}` : '1px solid var(--line)',
      cursor: onClick ? 'pointer' : 'default', overflow: 'hidden',
    }} className="e2-fade-up">
      {glow && <div style={{ position: 'absolute', top: -40, right: -30, width: 120, height: 120, borderRadius: '50%', background: glow, filter: 'blur(40px)', pointerEvents: 'none', opacity: 0.5 }} />}
      <div style={{ position: 'relative' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
          <TypeBadge kind={post.kind} />
          <ThemeTags tags={post.tags} />
        </div>
        {children}
      </div>
    </article>);
}

/* ---------- tags de tema (Fios) ---------- */
export function ThemeTags({ tags }: any) {
  const { onOpenTheme } = useStudy();
  if (!tags || !tags.length) return null;
  return (
    <div style={{ display: 'flex', gap: 5, flexShrink: 0 }}>
      {tags.slice(0, 1).map((t: string) =>
        <button key={t} onClick={(e) => { e.stopPropagation(); onOpenTheme && onOpenTheme(t); }} style={{
          display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11, color: 'var(--ink-3)',
          background: 'var(--paper-3)', padding: '3px 9px', borderRadius: 999, fontWeight: 500,
        }}>
          <span style={{ width: 5, height: 5, borderRadius: '50%', background: 'var(--ember)' }} />{t}
        </button>)}
    </div>);
}

/* ---------- Badge de temperatura ---------- */
export function HeatBadge({ heat }: any) {
  if (heat.level === 0) return null;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center', gap: 5, padding: '3px 9px 3px 7px', borderRadius: 999,
      background: 'color-mix(in oklab, ' + heat.color + ' 14%, transparent)', color: heat.color,
      fontFamily: 'var(--font-mono)', fontSize: 10.5, fontWeight: 600, letterSpacing: '0.04em', textTransform: 'uppercase',
    }}>
      <IcoFlame size={12} fill={heat.level >= 2 ? heat.color : 'none'} />{heat.label}
    </span>);
}

export function ThemeChip({ tag }: any) {
  const { onOpenTheme } = useStudy();
  if (!tag) return null;
  return (
    <button onClick={(e) => { e.stopPropagation(); onOpenTheme && onOpenTheme(tag); }} style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 11, color: 'var(--ink-4)', fontWeight: 500, padding: '4px 6px' }}>
      <IcoTheme size={12} />{tag}
    </button>);
}

/* CTA de discussão — usa post.comments do backend (não pré-carrega threads). */
export function DiscussionCTA({ post }: any) {
  const { onOpenComments } = useStudy();
  const n = post.comments || 0;
  return (
    <button onClick={() => onOpenComments(post)} style={{
      width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '10px 13px', borderRadius: 12, background: 'var(--paper-3)', color: 'var(--ink-2)',
      fontSize: 13.5, fontWeight: 600, marginTop: 14,
    }}>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 9, minWidth: 0 }}>
        <IcoComment size={17} style={{ color: 'var(--ink-3)' }} />
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{n > 0 ? `${n} na discussão` : 'Abrir discussão'}</span>
      </span>
      <IcoChevron size={16} style={{ color: 'var(--ink-3)' }} />
    </button>);
}

/* ============================================================ LIÇÃO ============================================================ */
export function LicaoCard({ post }: any) {
  const { onReact, onOpenReading, onOpenComments, canPost } = useStudy();
  const { concept, body } = parseLicao(post.text);
  const learned = post.reactions?.aprendi || 0;
  const youLearned = (post.yourReactions || []).includes('aprendi');
  const lead = stripMd((body.split('\n').map((l: string) => l.trim()).filter((l: string) => l && !l.startsWith('#'))[0] || ''));
  const steps = (body.match(/^##\s(.+)$/gm) || []).map((s: string) => s.replace(/^##\s/, ''));
  return (
    <article className="e2-fade-up" style={{
      background: 'linear-gradient(168deg, color-mix(in oklab, var(--lapis) 9%, var(--paper-2)), var(--paper-2) 60%)',
      borderRadius: 16, border: '1px solid color-mix(in oklab, var(--lapis) 22%, var(--line))',
      borderLeft: '2.5px solid var(--lapis)', padding: '16px 16px 12px', position: 'relative', overflow: 'hidden',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, color: 'var(--lapis)', fontSize: 11, fontFamily: 'var(--font-mono)', letterSpacing: '0.05em', textTransform: 'uppercase', fontWeight: 600 }}>
          <span style={{ width: 22, height: 22, borderRadius: 7, background: 'var(--lapis-soft)', display: 'grid', placeItems: 'center' }}><IcoTeach size={13} /></span>
          Lição
        </span>
        {learned > 0 &&
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, padding: '3px 9px', borderRadius: 999, background: 'var(--lapis-soft)', color: 'var(--lapis)', fontSize: 11, fontWeight: 600 }}>
            <IcoBulb size={12} />ensinou {fmt(learned)}
          </span>}
      </div>
      <AuthorRow post={post} />
      <div onClick={() => onOpenReading(post)} style={{ cursor: 'pointer', marginTop: 13 }}>
        <div className="mono" style={{ fontSize: 10.5, color: 'var(--ink-3)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 3 }}>ensina</div>
        <h3 className="serif" style={{ margin: '0 0 9px', fontSize: 25, lineHeight: 1.18, color: 'var(--ink)', letterSpacing: '0.01em' }}>{concept}</h3>
        {steps.length > 0 &&
        <div className="scroll-x" style={{ display: 'flex', gap: 6, marginBottom: 10 }}>
            {steps.map((s: string, i: number) =>
              <span key={i} className="mono" style={{ flexShrink: 0, fontSize: 10.5, color: 'var(--ink-3)', background: 'var(--paper-3)', padding: '4px 9px', borderRadius: 999, display: 'inline-flex', alignItems: 'center', gap: 5 }}>
                <span style={{ color: 'var(--lapis)' }}>{i + 1}</span>{s}
              </span>)}
          </div>}
        <p style={{ margin: 0, color: 'var(--ink-2)', fontSize: 15, lineHeight: 1.6, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{lead}</p>
        <button onClick={(e) => { e.stopPropagation(); onOpenReading(post); }} style={{ marginTop: 9, display: 'inline-flex', alignItems: 'center', gap: 6, color: 'var(--lapis)', fontSize: 13.5, fontWeight: 600 }}>Aprender esta lição <IcoChevron size={14} /></button>
      </div>
      <div style={{ display: 'flex', gap: 8, marginTop: 14 }}>
        <button onClick={() => onReact(post.id, 'aprendi')} style={{
          flex: 1, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '12px',
          borderRadius: 12, fontSize: 14.5, fontWeight: 600, transition: 'all 0.2s',
          background: youLearned ? 'var(--lapis)' : 'var(--lapis-soft)', color: youLearned ? '#10201f' : 'var(--lapis)',
          border: `1px solid ${youLearned ? 'var(--lapis)' : 'color-mix(in oklab, var(--lapis) 30%, transparent)'}`,
          opacity: canPost === false ? 0.5 : 1, cursor: canPost === false ? 'not-allowed' : 'pointer',
        }}>
          <IcoBulb size={17} fill={youLearned ? '#10201f' : 'none'} />{youLearned ? 'Aprendi!' : 'Aprendi com isso'}
        </button>
        <button onClick={() => onOpenComments(post)} style={{
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 7, padding: '12px 16px',
          borderRadius: 12, fontSize: 14, fontWeight: 600, background: 'var(--paper-3)', color: 'var(--ink-2)',
        }}>
          <IcoQuestion size={16} />Dúvida{post.comments > 0 ? ` · ${post.comments}` : ''}
        </button>
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 2, marginTop: 8 }}>
        {REACTIONS.filter((r: any) => r.id !== 'aprendi').map((r: any) => {
          const active = (post.yourReactions || []).includes(r.id);
          const count = post.reactions?.[r.id] || 0; const Icon = r.Icon;
          return (
            <button key={r.id} onClick={() => onReact(post.id, r.id)} style={{ ...reactBtn(active, r.accent), opacity: canPost === false ? 0.45 : 1, cursor: canPost === false ? 'not-allowed' : 'pointer' }}>
              <Icon size={15} fill={active ? r.accent : 'none'} />{count > 0 && <span>{fmt(count)}</span>}
            </button>);
        })}
        <div style={{ flex: 1 }} />
        <span className="mono" style={{ fontSize: 10.5, color: 'var(--ink-4)', fontStyle: 'italic' }}>ensinar é aprender 2×</span>
      </div>
    </article>);
}

/* ============================================================ POST DE TEXTO UNIFICADO ============================================================ */
export function TextPostCard({ post }: any) {
  const { onOpenReading, clubBook } = useStudy();
  const heat = postHeat(post);
  const isQ = post.kind === 'question';
  const isCit = post.kind === 'citation';
  const deep = post.kind === 'reflection' && (/^##\s/m.test(post.text || '') || heat.level >= 2);
  const tag = (post.tags || [])[0];

  return (
    <article className="e2-fade-up" style={{
      background: 'var(--paper-2)', borderRadius: 16, border: '1px solid var(--line)',
      padding: '15px 16px 11px', boxShadow: 'var(--shadow-card)',
    }}>
      <AuthorRow post={post} />

      {isQ &&
      <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginTop: 12, color: 'var(--sage)', fontSize: 11, fontFamily: 'var(--font-mono)', textTransform: 'uppercase', letterSpacing: '0.05em', fontWeight: 600 }}>
          <IcoQuestion size={13} />Pergunta aberta
        </div>}

      {isCit ?
      <div style={{ marginTop: 13 }}>
          <div style={{ position: 'relative', paddingLeft: 15 }}>
            <div style={{ position: 'absolute', left: 0, top: 5, bottom: 5, width: 3, borderRadius: 3, background: 'linear-gradient(var(--plum), color-mix(in oklab, var(--plum) 40%, transparent))' }} />
            <blockquote className="serif" style={{ margin: 0, fontSize: 21, lineHeight: 1.34, color: 'var(--ink)' }}>
              <span style={{ color: 'var(--plum)', opacity: 0.55, marginRight: 1 }}>“</span>{post.text}
            </blockquote>
            <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginTop: 10 }}>
              {clubBook && <BookCover book={clubBook} w={13} h={18} />}
              <span className="mono" style={{ fontSize: 10.5, color: 'var(--plum)' }}>{clubBook?.author || ''}{post.page ? ` · p. ${post.page}` : ''}</span>
            </div>
          </div>
          {post.comment && <p style={{ margin: '14px 0 0', fontSize: 15, lineHeight: 1.6, color: 'var(--ink-2)' }}>{inlineRich(post.comment, 'cc' + post.id)}</p>}
        </div> :
      deep ?
      <div onClick={() => onOpenReading(post)} style={{ cursor: 'pointer', marginTop: 12 }}>
          {heat.level >= 2 && <div style={{ marginBottom: 8 }}><HeatBadge heat={heat} /></div>}
          <h3 className="serif" style={{ margin: '0 0 6px', fontSize: 22, lineHeight: 1.2, color: 'var(--ink)' }}>{(post.text.match(/^##\s(.+)$/m) || [])[1] || 'Estudo'}</h3>
          <p style={{ margin: 0, fontSize: 15, lineHeight: 1.6, color: 'var(--ink-2)', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{stripMd(post.text.split('\n').find((l: string) => l.trim() && !/^(## |> |- |— )/.test(l)) || post.text)}</p>
          <button onClick={(e) => { e.stopPropagation(); onOpenReading(post); }} style={{ marginTop: 9, display: 'inline-flex', alignItems: 'center', gap: 6, color: 'var(--ember)', fontSize: 13, fontWeight: 600 }}>Ler completo <IcoChevron size={14} /></button>
        </div> :
      <div style={{ marginTop: isQ ? 8 : 11, fontSize: isQ ? 17.5 : 16, lineHeight: 1.55, color: 'var(--ink)', fontWeight: isQ ? 500 : 400 }}>
          {/\n\s*(>|##|-)\s/.test(post.text || '') ? <RichText text={post.text} /> : inlineRich(post.text || '', 'tx' + post.id)}
        </div>}

      <DiscussionCTA post={post} />
      <ReactionBar post={post} hideComment trailing={<ThemeChip tag={tag} />} />
    </article>);
}

/* ---------------- QUIZ ---------------- */
const quizNav = { display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 13, fontWeight: 600, color: 'var(--ink-3)', padding: '6px 4px' };
export function QuizCard({ post }: any) {
  const { onVote, canPost } = useStudy();
  const t = POST_TYPES.quiz;
  const [qi, setQi] = useState(0);
  const qs = post.questions || [];
  const q = qs[qi];
  const yourAnswers = post.yourAnswers || {};
  const answeredAll = qs.every((qq: any) => yourAnswers[qq.id]);
  if (!q) return null;
  const yourPick = yourAnswers[q.id];
  const answered = !!yourPick;

  return (
    <CardShell post={post} accent={t.accent}>
      <AuthorRow post={post} />
      {post.title && <h3 className="serif" style={{ margin: '13px 0 2px', fontSize: 22, lineHeight: 1.24, color: 'var(--ink)' }}>{post.title}</h3>}
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '8px 0 12px' }}>
        <span className="mono" style={{ fontSize: 11, color: 'var(--lapis)', textTransform: 'uppercase', letterSpacing: '0.05em' }}>Pergunta {qi + 1}/{qs.length}</span>
        <div style={{ flex: 1, display: 'flex', gap: 4 }}>
          {qs.map((_: any, i: number) => (
            <div key={i} style={{ flex: 1, height: 3, borderRadius: 2, background: i <= qi ? 'var(--lapis)' : 'var(--paper-3)' }} />
          ))}
        </div>
      </div>
      <div key={qi} className="e2-fade-up">
        <p style={{ margin: '0 0 12px', fontSize: 16, fontWeight: 600, color: 'var(--ink)', lineHeight: 1.4 }}>{q.text}</p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {q.options.map((o: any) => {
            const pct = q.totalVotes > 0 ? Math.round((o.votes / q.totalVotes) * 100) : 0;
            const isYour = yourPick === o.id;
            const showResult = answered;
            const isCorrect = post.hasGabarito && o.correct;
            let border = 'var(--line-strong)', tint = 'transparent', txtColor = 'var(--ink-2)';
            if (showResult) {
              if (isCorrect) { border = 'var(--sage)'; tint = 'var(--sage-soft)'; txtColor = 'var(--ink)'; }
              else if (isYour) { border = 'var(--ember)'; tint = 'var(--ember-soft)'; }
            }
            return (
              <button key={o.id} disabled={!canPost} onClick={() => onVote(post.id, q.id, o.id)} style={{
                position: 'relative', textAlign: 'left', padding: '12px 14px', borderRadius: 12,
                border: `1px solid ${border}`, background: tint, overflow: 'hidden', transition: 'all 0.2s',
                opacity: !canPost ? 0.6 : 1, cursor: canPost ? 'pointer' : 'not-allowed',
              }}>
                {showResult && <div style={{ position: 'absolute', inset: 0, width: pct + '%', background: isCorrect ? 'color-mix(in oklab, var(--sage) 16%, transparent)' : isYour ? 'color-mix(in oklab, var(--ember) 14%, transparent)' : 'var(--paper-3)', transition: 'width 0.5s cubic-bezier(0.2,0.8,0.2,1)' }} />}
                <div style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 10 }}>
                  <div style={{ width: 18, height: 18, borderRadius: '50%', border: `2px solid ${isYour ? (isCorrect ? 'var(--sage)' : 'var(--ember)') : 'var(--line-strong)'}`, flexShrink: 0, display: 'grid', placeItems: 'center' }}>
                    {isYour && <div style={{ width: 8, height: 8, borderRadius: '50%', background: isCorrect ? 'var(--sage)' : 'var(--ember)' }} />}
                  </div>
                  <span style={{ flex: 1, fontSize: 14.5, color: txtColor, fontWeight: isYour ? 600 : 400 }}>{o.text}</span>
                  {showResult && isCorrect && <IcoCheck size={16} style={{ color: 'var(--sage)' }} />}
                  {showResult && <span className="mono" style={{ fontSize: 12, color: 'var(--ink-3)', fontWeight: 600 }}>{pct}%</span>}
                </div>
              </button>);
          })}
        </div>
        {answered && (
          <div style={{ marginTop: 9, fontSize: 12, color: 'var(--ink-3)', display: 'flex', alignItems: 'center', gap: 6 }}>
            <IcoArrowUp size={13} style={{ color: 'var(--ink-4)' }} />
            {q.totalVotes} votos · toque outra opção para trocar
          </div>)}
        {!canPost && (
          <div style={{ marginTop: 9, fontSize: 12, color: 'var(--ink-4)', display: 'flex', alignItems: 'center', gap: 6 }}>
            <IcoLock size={12} />Entre no grupo pra votar
          </div>)}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 14 }}>
        <button disabled={qi === 0} onClick={() => setQi(qi - 1)} style={{ ...quizNav, opacity: qi === 0 ? 0.3 : 1 }}><IcoBack size={15} />Anterior</button>
        {qi < qs.length - 1
          ? <button onClick={() => setQi(qi + 1)} style={{ ...quizNav, color: 'var(--lapis)' }}>Próxima<IcoChevron size={15} /></button>
          : answeredAll
            ? <span className="mono" style={{ fontSize: 11.5, color: 'var(--sage)', display: 'inline-flex', alignItems: 'center', gap: 5 }}><IcoCheck size={14} />Concluído</span>
            : <span className="mono" style={{ fontSize: 11.5, color: 'var(--ink-4)' }}>responda todas</span>}
      </div>
      <div style={{ marginTop: 10, borderTop: '1px solid var(--line)', paddingTop: 8 }}><ReactionBar post={post} /></div>
    </CardShell>);
}

/* ---------------- CAIXA DE PERGUNTAS ---------------- */
const qboxCTA = { marginTop: 14, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, padding: '13px', borderRadius: 12, fontSize: 14.5, fontWeight: 600 };
export function QuestionBoxCard({ post }: any) {
  const { isElevated, canPost, onAskQbox, onManageQbox } = useStudy();
  const t = POST_TYPES['question-box'];
  return (
    <CardShell post={post} accent={t.accent} glow="rgba(158,176,131,0.16)">
      <AuthorRow post={post} />
      <div style={{ margin: '14px 0 4px', display: 'flex', gap: 13, alignItems: 'flex-start' }}>
        <div style={{ width: 46, height: 46, borderRadius: 14, background: 'var(--sage-soft)', display: 'grid', placeItems: 'center', flexShrink: 0 }}>
          <IcoInbox size={24} style={{ color: 'var(--sage)' }} />
        </div>
        <div style={{ flex: 1 }}>
          <h3 style={{ margin: 0, fontSize: 17, lineHeight: 1.35, color: 'var(--ink)', fontWeight: 600 }}>{post.prompt}</h3>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 7 }}>
            <span className="mono" style={{ fontSize: 11, color: 'var(--ink-3)', display: 'inline-flex', alignItems: 'center', gap: 4 }}><IcoLock size={12} />anônimo</span>
            {post.closesIn && <span className="mono" style={{ fontSize: 11, color: 'var(--ink-3)', display: 'inline-flex', alignItems: 'center', gap: 4 }}><IcoClock size={12} />fecha em {post.closesIn}</span>}
          </div>
        </div>
      </div>
      {isElevated ? (
        <button onClick={() => onManageQbox(post)} style={{ ...qboxCTA, background: 'var(--ember)', color: '#1a1208', boxShadow: 'var(--shadow-ember)' }}>
          <IcoCrown size={16} />Ver e responder{post.questionsReceived ? ` · ${post.questionsReceived} perguntas` : ''}
        </button>
      ) : canPost ? (
        <button onClick={() => onAskQbox(post)} style={{ ...qboxCTA, background: 'var(--sage-soft)', color: 'var(--sage)', border: '1px solid color-mix(in oklab, var(--sage) 30%, transparent)' }}>
          <IcoPlus size={16} />Fazer uma pergunta anônima
        </button>
      ) : (
        <div style={{ ...qboxCTA, background: 'var(--paper-3)', color: 'var(--ink-4)', cursor: 'not-allowed' }}>
          <IcoLock size={15} />Entre no grupo pra perguntar
        </div>
      )}
      {post.questionsReceived > 0 && <div style={{ fontSize: 11.5, color: 'var(--ink-4)', textAlign: 'center', marginTop: 8 }}>{post.questionsReceived} pessoas já perguntaram</div>}
      <div style={{ marginTop: 8 }}><ReactionBar post={post} /></div>
    </CardShell>);
}

/* ---------------- RESPOSTA DO LÍDER ---------------- */
export function LeaderAnswerCard({ post }: any) {
  const t = POST_TYPES['leader-answer'];
  return (
    <CardShell post={post} accent={t.accent} glow="rgba(242,154,96,0.18)">
      <AuthorRow post={post} />
      <div style={{ margin: '13px 0', padding: '11px 13px', background: 'var(--paper)', borderRadius: 12, borderLeft: '2px solid var(--ember-2)' }}>
        <div className="mono" style={{ fontSize: 10, color: 'var(--ember-2)', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 4, display: 'flex', alignItems: 'center', gap: 5 }}>
          <IcoInbox size={12} />respondendo à caixa
        </div>
        <div style={{ fontSize: 14.5, color: 'var(--ink)', fontWeight: 500, lineHeight: 1.4 }}>{post.question}</div>
      </div>
      <RichText text={post.text} style={{ fontSize: 15, lineHeight: 1.6 }} />
      <DiscussionCTA post={post} />
      <ReactionBar post={post} hideComment />
    </CardShell>);
}

/* ---------------- INSIGHT FINAL ---------------- */
export function InsightFinalCard({ post }: any) {
  const { onOpenInsight } = useStudy();
  return (
    <article onClick={() => onOpenInsight(post)} className="e2-fade-up" style={{
      background: 'linear-gradient(170deg, color-mix(in oklab, var(--ember) 11%, var(--paper-2)), var(--paper-2) 55%)',
      borderRadius: 16, border: '1px solid color-mix(in oklab, var(--ember) 24%, var(--line))',
      padding: '18px 16px 13px', position: 'relative', overflow: 'hidden', cursor: 'pointer',
      boxShadow: '0 4px 20px rgba(232,122,59,0.10)',
    }}>
      <div style={{ position: 'absolute', top: -30, right: -10, opacity: 0.10 }}><IcoTrophy size={130} style={{ color: 'var(--ember)' }} /></div>
      <div style={{ position: 'relative' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
          <span style={{ display: 'inline-flex', alignItems: 'center', gap: 7, color: 'var(--ember-2)', fontFamily: 'var(--font-mono)', fontSize: 11, letterSpacing: '0.06em', textTransform: 'uppercase', fontWeight: 600 }}>
            <IcoTrophy size={15} />Insight Final
          </span>
          <span className="mono" style={{ fontSize: 10.5, color: 'var(--ink-3)' }}>marco encerrado</span>
        </div>
        <AuthorRow post={post} />
        {post.milestoneLabel && (
          <div className="mono" style={{ fontSize: 11, color: 'var(--ink-3)', margin: '13px 0 3px', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'flex', alignItems: 'center', gap: 6 }}>
            <IcoCheck size={13} style={{ color: 'var(--sage)' }} />{post.milestoneLabel}
          </div>)}
        <h3 className="serif" style={{ margin: '2px 0 14px', fontSize: 26, lineHeight: 1.24, color: 'var(--ink)' }}>{post.title}</h3>
        <p style={{ margin: 0, fontSize: 15.5, lineHeight: 1.62, color: 'var(--ink-2)', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
          {stripMd(post.text || '').split('\n')[0]}
        </p>
        <button style={{ marginTop: 11, display: 'inline-flex', alignItems: 'center', gap: 6, color: 'var(--ember)', fontSize: 13.5, fontWeight: 600 }}>
          Abrir insight <IcoChevron size={14} />
        </button>
        <div style={{ marginTop: 12, paddingTop: 4 }}><ReactionBar post={post} /></div>
      </div>
    </article>);
}

/* ---------------- DISPATCHER ---------------- */
export function PostCard({ post }: any) {
  switch (post.kind) {
    case 'reflection': return isLicao(post) ? <LicaoCard post={post} /> : <TextPostCard post={post} />;
    case 'citation': return <TextPostCard post={post} />;
    case 'question': return <TextPostCard post={post} />;
    case 'quiz': return <QuizCard post={post} />;
    case 'question-box': return <QuestionBoxCard post={post} />;
    case 'leader-answer': return <LeaderAnswerCard post={post} />;
    case 'insight-final': return <InsightFinalCard post={post} />;
    default: return null;
  }
}
